// Central Google AdSense configuration (§16-19). Every AdSlot/loader reads from here —
// no raw AdSense script code or account IDs are scattered across individual pages.
//
// IMPORTANT: process.env.REACT_APP_* must be accessed via static literal property
// access (`process.env.REACT_APP_X`) for Create React App's webpack build to inline
// the value — a dynamic/computed lookup (`process.env[someVariable]`) is NOT replaced
// at build time and will always be undefined in the shipped bundle. This is why ad
// slot IDs are listed explicitly below rather than derived from a placement string.
//
// No AdSense account/client ID/ad-unit ID is fabricated anywhere in this file or its
// callers. Every value is either a real environment variable or an explicit "not
// configured" state.

const ADSENSE_ENABLED = process.env.REACT_APP_ADSENSE_ENABLED === "true";
const ADSENSE_CLIENT_ID = process.env.REACT_APP_ADSENSE_CLIENT_ID || "";

// One entry per placement this app actually uses. Add a new placement by adding one
// line here (plus the corresponding REACT_APP_AD_SLOT_* environment variable) — never
// by hardcoding a slot ID inside a page component.
const AD_SLOT_IDS = {
  public_content_sidebar: process.env.REACT_APP_AD_SLOT_PUBLIC_CONTENT_SIDEBAR || "",
  public_content_inline: process.env.REACT_APP_AD_SLOT_PUBLIC_CONTENT_INLINE || "",
  public_footer: process.env.REACT_APP_AD_SLOT_PUBLIC_FOOTER || "",
};

export const ADS_CONFIG = {
  provider: "google-adsense",
  enabled: ADSENSE_ENABLED,
  clientId: ADSENSE_CLIENT_ID,
  consentRequirement: "required", // ads never load without explicit accepted consent — see cookieConsent.js
  environment: process.env.NODE_ENV,
};

export function isAdsenseConfigured() {
  return ADS_CONFIG.enabled && Boolean(ADS_CONFIG.clientId);
}

export function slotIdForPlacement(placement) {
  return AD_SLOT_IDS[placement] || "";
}

export function knownPlacements() {
  return Object.keys(AD_SLOT_IDS);
}

// Diagnostic snapshot for the admin "Google AdSense" panel (§56) — booleans/counts
// only, never the actual client ID or slot IDs, even to an authenticated admin, since
// there is no operational reason an admin diagnostic needs to display the values back
// (they're already visible to the person who set the environment variables) and
// keeping the diagnostic output free of them removes any risk of accidental exposure
// through a screenshot, support ticket, or logging.
export function adsenseDiagnostics() {
  const configuredPlacements = knownPlacements().filter((p) => Boolean(slotIdForPlacement(p)));
  return {
    enabled: ADS_CONFIG.enabled,
    clientIdConfigured: Boolean(ADS_CONFIG.clientId),
    configuredPlacementCount: configuredPlacements.length,
    totalKnownPlacements: knownPlacements().length,
    consentIntegration: "ready", // the consent hook exists and gates loading regardless of enabled state
    live: isAdsenseConfigured(),
  };
}
